import { Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { useParams } from 'react-router-dom';

export const HeaderTitle = () => {
  const dictionary = Dictionary[DICTIONARY.Equipment];
  const params = useParams();

  const isDesktop = useIsDesktop();
  return (
    <>
      <Typography
        fontWeight={700}
        fontSize={'28px'}
        variant='h2'
        component={'h1'}
        mt={2}
        tabIndex={0}
      >
        {dictionary.createOrder.title}{' '}
        {params.id
          ? ` - ${dictionary.RecentOrders.duplicateOrder} ${parseInt(
              params.id
            )}`
          : ''}
      </Typography>
      <Typography variant='body3' mt={isDesktop ? 2 : 1} tabIndex={0}>
        {dictionary.createOrder.subTitle}
      </Typography>
    </>
  );
};
